import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppSelector } from 'shared/lib';

import { HeaderSchedule } from '../../headerSchedule';
import { SettingsToolbar } from '../../settingsToolbar';

import styles from './styles.module.scss';
export const LayoutSchedule: FC = () => {
  const { headerSwitchStage } = useAppSelector(
    (state) => state.viewStageReducer,
  );
  return (
    <div className={styles['layout']}>
      <div className={styles['container']}>
        <HeaderSchedule />
        {headerSwitchStage !== 'exams' && <SettingsToolbar />}
        <Outlet />
      </div>
    </div>
  );
};
